<template>
  <zh-table-page
    ref="tableRef"
    v-bind="{
      title: '角色管理',
      search,
      api,
      ...table,
    }"
    @action="handleAction"
  >
    <template #header-btn>
      <el-button type="primary" @click="handlAdd">新增</el-button>
      <el-button type="danger" @click="handlDelete">批量删除</el-button>
    </template>
  </zh-table-page>
  <el-dialog v-model="dialogVisible" :title="dialogTitle">
    <el-form
      ref="dialogFormRef"
      :model="dialogForm"
      :rules="dialogRules"
      label-width="120px"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="角色名称" prop="roleName">
            <el-input
              v-model="dialogForm.roleName"
              placeholder="请输入角色名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态">
            <s-select
              url="postDictDataList"
              :params="{ dictType: 'center_use_state' }"
              :field="{
                dictValue: 'value',
                dictLabel: 'label',
              }"
              v-model="dialogForm.state"
              placeholder="请选择状态"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排序">
            <el-input-number
              v-model="dialogForm.showOrder"
              :step="1"
              step-strictly
              :min="1"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="菜单权限">
            <el-checkbox v-model="menuExpand">展开/折叠</el-checkbox>
            <el-checkbox v-model="menuNodeAll">全选/全不选</el-checkbox>
            <div style="width: 100%">
              <el-tree
                ref="menuRef"
                :data="treeData"
                show-checkbox
                @check="handleNodeClick"
                node-key="id"
                v-if="dialogVisible"
                :default-checked-keys="defaultCheckedKeys"
              />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input
              v-model="dialogForm.remark"
              :rows="2"
              type="textarea"
              placeholder="请输入备注"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveRole"> 确认 </el-button>
      </span>
    </template>
  </el-dialog>
  <el-dialog v-model="userVisible" title="设置人员" width="700">
    <el-row class="container">
      <el-col :span="8">
        <el-tree
          ref="orgTreeRef"
          :data="orgTreeData"
          :expand-on-click-node="false"
          @current-change="handleOrgTreeNodeChange"
          highlight-current
          node-key="id"
          default-expand-all
        />
      </el-col>
      <el-col :span="16">
        <el-form ref="dialogFormRef" :model="dialogForm" label-width="100px">
          <el-form-item label="角色名称" prop="roleName">
            <el-input
              v-model="dialogForm.roleName"
              placeholder="请输入角色名称"
              disabled
            />
          </el-form-item>
          <el-form-item label="人员选择" prop="roleName">
            <el-checkbox-group v-model="userCheckList">
              <el-checkbox
                :label="item.userCode"
                v-for="item in userData"
                :key="item.userCode"
                >{{ item.nikeName }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="userVisible = false">取消</el-button>
        <el-button type="primary" @click="saveSetUser"> 确认 </el-button>
      </span>
    </template>
  </el-dialog>
  <el-dialog v-model="dataVisible" title="数据权限" width="700">
    <el-form ref="dialogFormRef" :model="dialogForm" label-width="100px">
      <el-form-item label="角色名称" prop="roleName">
        <el-input
          v-model="dialogForm.roleName"
          placeholder="请输入角色名称"
          disabled
        />
      </el-form-item>
      <el-form-item label="权限范围" prop="">
        <s-select
          :options="options"
          v-model="dialogForm.state"
          placeholder="请选择状态"
        />
      </el-form-item>
      <el-form-item label="菜单权限">
        <el-checkbox v-model="menuExpand">展开/折叠</el-checkbox>
        <el-checkbox v-model="menuNodeAll">全选/全不选</el-checkbox>
        <div style="width: 100%">
          <el-tree
            ref="menuRef"
            :data="treeData"
            show-checkbox
            @check="handleNodeClick"
            node-key="id"
            v-if="dataVisible"
            :default-checked-keys="defaultCheckedKeys"
          />
        </div>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dataVisible = false">取消</el-button>
        <el-button type="primary" @click="saveSetData"> 确认 </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch,
  computed,
} from "vue";
import { useRouter } from "vue-router";
import { replaceObjectKeys } from "@pansy/utils";
import { ElMessageBox } from "element-plus";

export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const tableRef = ref();
    const menuRef = ref();
    const dialogFormRef = ref();
    const orgTreeRef = ref();
    const state = reactive({
      search: [
        {
          label: "角色名称",
          placeholder: "角色名称",
          value: "roleName",
        },
        // {
        //   label: "权限字符",
        //   placeholder: "权限字符",
        //   value: "roleKey",
        // },
        {
          component: "zh-select",
          label: "角色状态",
          placeholder: "角色状态",
          value: "state",
          url: "postDictDataList",
          params: {
            dictType: "center_use_state",
          },
          field: {
            dictValue: "value",
            dictLabel: "label",
          },
        },
        // {
        //   component: "el-date-picker",
        //   label: "创建日期",
        //   placeholder: "创建日期",
        //   value: "date",
        //   size: "large",
        //   date1: "beginTime",
        //   date2: "endTime",
        // },
      ],
      api: {
        list: "postRolePage",
        delete: "deleteRoleDeleteBatch",
        deleteAll: "",
        exportAll: "/system/role/export",
        add: null,
        edit: null,
        detail: null,
        path: "", //详情页面路由
      },
      table: {
        columns: [
          { type: "selection", width: 55 },
          { label: "角色名称", prop: "roleName" },
          { label: "显示顺序", prop: "showOrder" },
          {
            label: "状态",
            prop: "state",
            scopeComponent: "common-switch",
          },
          { label: "备注信息", prop: "remark" },
        ],
        rowKey: "roleCode",
        operations: [
          {
            label: "编辑",
            custom: true,
            disabledFun: (row) => {
              return row.roleCode == 1;
            },
          },
          {
            label: "设置人员",
            disabledFun: (row) => {
              return row.state.value == 1;
            },
          },
          { label: "删除", type: "danger" },
        ],
        operationsWidth: "200",
      },

      dialogVisible: false,
      dialogTitle: "新增角色",
      dialogRules: {
        roleName: [
          { required: true, message: "角色不能为空", trigger: "blur" },
        ],
      },
      dialogForm: {
        menus: "",
        users: "",
        remark: "",
        roleCode: "",
        roleName: "",
        showOrder: "",
        state: "",
      },
      treeData: [],
      orgTreeData: [],
      checkedNodes: [],
      defaultCheckedKeys: [],
      menuExpand: false,
      menuNodeAll: false,
      userVisible: false,
      userData: [],
      userCheckList: [],
      dataVisible: false,
      options: [
        { label: "全部数据权限", value: "1" },
        { label: "自定义数据权限", value: "1" },
        { label: "本部门数据权限", value: "1" },
        { label: "本部门及以下数据权限", value: "1" },
        { label: "仅本人数据权限", value: "1" },
      ],
    });
    onMounted(() => {
      getMenu();
      getOrg();
    });
    const getMenu = () => {
      proxy.$api.getMenuGetMenuTree().then((res) => {
        if (res.data) {
          state.treeData = replaceObjectKeys(
            res.data,
            {
              menuName: "label",
              menuCode: "id",
            },
            {
              simplify: false,
            }
          );
        }
      });
    };
    const getOrg = () => {
      proxy.$api.getOrganizationalGetOrganizationalTreeSelect().then((res) => {
        if (res.data) {
          state.orgTreeData = replaceObjectKeys(
            res.data,
            {
              organizationName: "label",
              organizationCode: "id",
            },
            {
              simplify: false,
            }
          );
        }
      });
    };
    const getUser = (orgCode) => {
      if (orgCode) {
        // 根据部门查询
        proxy.$api.getUserByOrgCode(orgCode).then((res) => {
          if (res.data) {
            state.userData = res.data;
          }
        });
      } else {
        // 查询所有
        proxy.$api.postUserList({}).then((res) => {
          if (res.data) {
            state.userData = res.data;
          }
        });
      }
    };

    const handleAction = (item, type) => {
      if (type === "scope") {
        proxy
          .$confirm("是否修改角色状态?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            proxy.$api.getRole(item.roleCode).then((res) => {
              proxy.$api
                .postRoleUpdate({
                  ...res.data,
                  state: res.data.state.value == 1 ? 0 : 1,
                })
                .then((res) => {
                  tableRef.value.handleSearch();
                  proxy.$message.success("操作成功");
                });
            });
          })
          .catch(() => {
            tableRef.value.handleSearch();
          });
      } else {
        handlEdit(item, type);
      }
    };
    //点击编辑
    const handlEdit = (scope, type) => {
      proxy.$api.getRole(scope.row.roleCode).then((res) => {
        if (res.data) {
          state.checkedNodes = res.data.menus ? res.data.menus.split(",") : [];
          state.defaultCheckedKeys = res.data.menus
            ? res.data.menus.split(",")
            : [];
          state.dialogForm = {
            menus: res.data.menus,
            remark: res.data.remark,
            roleCode: res.data.roleCode,
            roleName: res.data.roleName,
            showOrder: res.data.showOrder,
            state: res.data.state.value,
          };
          if (type === "编辑") {
            state.dialogTitle = "编辑角色";
            state.dialogVisible = true;
          } else if (type === "设置人员") {
            state.userCheckList = res.data.userCodes
              ? res.data.userCodes.split(",")
              : [];
            getUser();
            state.userVisible = true;
            orgTreeRef.value.setCurrentKey(null);
          } else if (type === "data") {
            state.dataVisible = true;
          }
        }
      });
    };
    //点击新增
    const handlAdd = () => {
      state.checkedNodes = [];
      state.defaultCheckedKeys = [];
      state.menuExpand = false;
      state.menuNodeAll = false;
      state.dialogTitle = "新增角色";
      state.dialogForm = {
        menus: "",
        remark: "",
        roleCode: "",
        roleName: "",
        showOrder: 1,
        state: 0,
      };
      state.dialogVisible = true;
    };
    //新增/编辑 保存
    const saveRole = () => {
      dialogFormRef.value.validate((valid, fields) => {
        if (valid) {
          let url =
            state.dialogTitle === "新增角色"
              ? "postRoleSave"
              : "postRoleUpdate";
          proxy.$api[url]({
            roleCode: state.dialogForm?.roleCode ?? null,
            roleName: state.dialogForm.roleName,
            remark: state.dialogForm.remark,
            showOrder: state.dialogForm.showOrder,
            state: state.dialogForm.state,
            menus: state.checkedNodes.join(","),
          }).then((res) => {
            tableRef.value.handleSearch();
            proxy.$message.success("操作成功");
            state.dialogVisible = false;
          });
        }
      });
    };
    const saveSetUser = () => {
      proxy.$api
        .postRoleUpdate({
          ...state.dialogForm,
          users: state.userCheckList.join(","),
        })
        .then((res) => {
          tableRef.value.handleSearch();
          proxy.$message.success("操作成功");
          state.userVisible = false;
        });
    };
    const saveSetData = () => {
      proxy.$api
        .postRoleUpdate({
          ...state.dialogForm,
        })
        .then((res) => {
          tableRef.value.handleSearch();
          proxy.$message.success("操作成功");
          state.userVisible = false;
        });
    };
    //点击树
    const handleOrgTreeNodeChange = (row, node) => {
      getUser(row.id);
    };

    //点击树
    const handleNodeClick = (data, node) => {
      state.checkedNodes = node.checkedKeys;
    };

    //全部展开/折叠
    watch(
      () => state.menuExpand,
      (n) => {
        unFoldAll(state.treeData, n);
      }
    );
    const unFoldAll = (data, n) => {
      data.forEach((el) => {
        menuRef.value.store.nodesMap[el.id].expanded = n;
        el.children && el.children.length > 0 ? unFoldAll(el.children) : ""; //
      });
    };

    //全选/全不选
    watch(
      () => state.menuNodeAll,
      (n) => {
        state.checkedNodes = [];
        menuRef.value.setCheckedNodes(n ? state.treeData : []);
        nodeAll(n ? state.treeData : []);
      }
    );
    const nodeAll = (data) => {
      data.forEach((el) => {
        state.checkedNodes.push(el.id);
        el.children && el.children.length > 0 ? nodeAll(el.children) : ""; //
      });
    };
    //批量删除
    const handlDelete = () => {
      if (tableRef.value.selections.length === 0) {
        proxy.$message.warning("请选择数据");
      } else {
        ElMessageBox.confirm("是否删除当前选中?", "删除提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const params = tableRef.value.selections.map(
              (item) => item[state.table.rowKey]
            );
            proxy.$api.deleteRoleDeleteBatch(params.join(",")).then((res) => {
              tableRef.value.handleSearch();
              proxy.$message.success("操作成功");
            });
          })
          .catch(() => {});
      }
    };
    return {
      ...toRefs(state),
      tableRef,
      menuRef,
      dialogFormRef,
      orgTreeRef,
      handleAction,
      handlAdd,
      saveRole,
      handleNodeClick,
      handleOrgTreeNodeChange,
      handlEdit,
      saveSetUser,
      saveSetData,
      handlDelete,
    };
  },
});
</script>
